import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@spotahome/ui-library';
import { trans, withClientConfig } from '@spotahome/soyuz/client';

import LoginSignUpModal from '../../../common/components/login/LoginModal';
import FavoritesCrossDevices from '../../../common/components/icons/FavoritesCrossDevices';
import withModalHandle from '../../../common/components/withModalHandle';

import './EmptyFavorites.scss';

const modalEvents = {
  open: {
    eventCategory: 'signup/login modal',
    eventAction: 'Favourites',
    eventLabel: 'open'
  },
  close: {
    eventCategory: 'signup/login modal',
    eventAction: 'Favourites',
    eventLabel: 'close'
  }
};

const EmptyFavoritesLogged = ({
  handleModalOpen,
  handleModalClose,
  isModalOpen,
  clientConfig
}) => (
  <div className="empty-favorites" id="no-results">
    <div className="empty-favorites__wrapper">
      <FavoritesCrossDevices />
      <p className="empty-favorites__text">
        {trans('favorites.message.will_appear.not_logged')}
      </p>
    </div>
    <div className="empty-favorites__button-container">
      <Button
        alt
        className="empty-favorites__back-to-search ga-favorites-page-back-button"
        href="/"
      >
        {trans('favorites.message.continue_searching')}
      </Button>
      {clientConfig.featureToggle.login && (
        <Button
          className="empty-favorites__new-account ga-favorites-page-account-button"
          onClick={handleModalOpen}
        >
          {trans('favorites.message.sign_up')}
        </Button>
      )}
    </div>
    {clientConfig.featureToggle.login && (
      <LoginSignUpModal
        onClose={handleModalClose}
        initialAction="signup"
        isOpen={isModalOpen}
      />
    )}
  </div>
);

EmptyFavoritesLogged.propTypes = {
  handleModalOpen: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired
};

export default withClientConfig()(
  withModalHandle(modalEvents)(EmptyFavoritesLogged)
);
